import { render } from "./ToolSuggestionCard.vue?vue&type=template&id=fbfcba9e&scoped=true"
import script from "./ToolSuggestionCard.vue?vue&type=script&lang=js"
export * from "./ToolSuggestionCard.vue?vue&type=script&lang=js"

import "./ToolSuggestionCard.vue?vue&type=style&index=0&id=fbfcba9e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfcba9e"]])

export default __exports__